var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"w5EJS_uLr4eI9F1bCT3Yw"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["sipec-frontend@webranking-srl"]={id:"w5EJS_uLr4eI9F1bCT3Yw"};
      